import * as React from 'react'
import { useState, useEffect } from 'react'

import { useParams, useNavigate } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import Swal from 'sweetalert2'
import { Box, Tooltip, FormControl, Select, MenuItem } from '@mui/material'
import { Link } from 'react-router-dom'
import axios from '../../lib/axios'

import AddButton from '../../components/AddButton'
import PurchaseContractsItemsTable from '../../components/customers_vendors/PurchaseContractsItemsTable'
import { useStateContext } from '../../context/ContextProvider'
import Loading from '../../components/Loading'
import AddPurchaseItem from '../../components/customers_vendors/AddPurchaseItem'
import { isNull } from 'lodash'
import { isValid } from '../../helpers/helper'

const UpdatePurchaseContracts = () => {

    const { t } = useTranslation()
    const params = useParams()
    const { config, pusher } = useStateContext()
    const [isLoading, setIsLoading] = useState(false)
    const navigate = useNavigate()

    const [vendorId, setvendorId] = useState('')
    const [vendorName, setvendorName] = useState('')
    const [purchaseAddress, setpurchaseAddress] = useState('')
    const [purchaseAddressName, setpurchaseAddressName] = useState('')
    const [address, setAddress] = useState([])
    const [items, setItems] = useState([])
    const [openItem, setOpenItem] = useState(false)

    useEffect(() => {
        const channeldelete = pusher.subscribe(`${localStorage.getItem('client_id')}-purchasecontract-deleted`)
        const channelupdate = pusher.subscribe(`${localStorage.getItem('client_id')}-purchasecontract-updated`)

        channeldelete.bind(`${localStorage.getItem('client_id')}-purchasecontract-deleted-event`, data => {
            if(Number(data.id) == Number(params.id)) {
                navigate(`/vendors/${data.vendor_id}?tab=purchase-contracts`)
            }
        })

        channelupdate.bind(`${localStorage.getItem('client_id')}-purchasecontract-updated-event`, data => {
            if(Number(data.id) == Number(params.id)) {
                setItems([])
                getPurchaseContract()
            }
        })

        return (() => {
            pusher.unsubscribe(`${localStorage.getItem('client_id')}-purchasecontract-deleted`)
            pusher.unsubscribe(`${localStorage.getItem('client_id')}-purchasecontract-updated`)
            pusher.unsubscribe(`${localStorage.getItem('client_id')}-vendor-deleted`)
        })
    }, [])

    useEffect(() => {
        function handleKeyDown(e) {
            if (e.keyCode == '27') {
                navigate(-1)
            }
        }

        document.addEventListener('keydown', handleKeyDown);

        return function cleanup() {
            document.removeEventListener('keydown', handleKeyDown);
        }
    }, []);

    useEffect(() => {
        getPurchaseContract()
    }, [])

    useEffect(() => {
        if (purchaseAddress) {
            getPurchaseAddress(purchaseAddress)
        }
    }, [purchaseAddress])

    useEffect(() => {
        if(isValid(vendorId)) {
            const channelVendorDeleted = pusher.subscribe(`${localStorage.getItem('client_id')}-vendor-deleted`)

            channelVendorDeleted.bind(`${localStorage.getItem('client_id')}-vendor-deleted-event`, data => {
                if(Number(data.id) == Number(vendorId)) {
                    navigate('/vendors')
                }
            })
        }

        return (() => {
            if(isValid(vendorId)) {
                pusher.unsubscribe(`${localStorage.getItem('client_id')}-vendor-deleted`)
            }
        })
    }, [vendorId])

    /* requests */
    const getPurchaseContract = async (id = null) => {
        setIsLoading(true)
        await axios.get(`/api/purchase-contracts/${isNull(id) ? params.id : id}`, config)
            .then(res => {
                const salesContract = res.data
                setvendorId(salesContract?.vendor_id)
                setvendorName(salesContract?.vendor_name)
                setpurchaseAddress(salesContract?.purchase_address_id)
                setpurchaseAddressName(salesContract?.purchase_name)
                setItems(salesContract?.purchase_contract_items)
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    const getPurchaseAddress = async (id) => {
        setIsLoading(true)
        await axios.get(`/api/purchase-addresses/${id}`, config)
            .then(res => {
                const shipTo = res.data
                setAddress(shipTo)
                setIsLoading(false)
            })
    }

    const updatePurchaseContract = async (e) => {
        e.preventDefault();
        setIsLoading(true)
        const formData = {}

        formData['vendor_id'] = vendorId
        formData['purchase_address_id'] = purchaseAddress
        formData['purchase_contract_items'] = items

        await axios.put(`/api/purchase-contracts/${params.id}`, formData, config).then(({ data }) => {
            Swal.fire({
                icon: "success",
                customClass: 'success',
                showCloseButton: true,
                iconColor: '#00B78E',
                text: data.success.message
            })
            setIsLoading(false)
        }).catch(({ response }) => {
            Swal.fire({
                text: response.data.message,
                icon: "error",
                customClass: 'error',
                showCloseButton: true,
                iconColor: '#FF0000'
            })
            setIsLoading(false)
        })
    }

    /* handlers */

    const handleCloseItem = () => setOpenItem(!openItem)

    const updateItem = (id, quantity, unit_price) => {
        const itemsCopy = [...items]
        const item = itemsCopy.find(item => item.id === id)

        item.quantity = quantity
        item.unit_price = unit_price
        item.total_cost = quantity * unit_price

        setItems(itemsCopy)
    }

    return (
        <>
            {isLoading ? <Loading /> : ''}
            <Box sx={{ background: '#F5F5FD', minHeight: '100vh' }}>
                <div className='flex justify-between items-center p-5 w-full bg-white' style={{ borderRadius: '5px 5px 0 0' }}>
                    <div className='flex items-center justify-between w-full leading-none'>
                        <p className='text-[18px] font-[600] text-[#333333] flex items-center'><span className='text-[#650D1B] text-[35px] mr-4'>•</span> {t('editPurchaseContract')} - {params.id}</p>
                        <div style={{ transform: "rotate(45deg)" }} className="font-[600] text-[#333333]">
                            <Link to={`/vendors/${vendorId}?tab=purchase-contracts`}><i className="fa-solid fa-plus"></i></Link>
                        </div>
                    </div>
                </div>
                <div className='p-5 pb-12 flex justify-between gap-3 flex-col lg:flex-row'>
                    <div className='bg-white p-6 pt-0 rounded-md w-full lg:w-2/5 h-fit edit-view'>
                        <div className='pb-11 pt-1'>
                            <p className='text-[13px] font-[600] uppercase text-[#A1ACB8]'>{t('general_information')}</p>
                        </div>
                        <div className='w-full pb-4'>
                            <p className="text-[14px] text-[#718096]">{t('vendor')} *</p>
                            <div className='w-full'>
                                <FormControl sx={{ width: '100%' }}>
                                    <Select value={vendorId} disabled
                                        sx={{
                                            width: '100%', background: '#FCFCFC', '.MuiOutlinedInput-input': { padding: '9px !important' },
                                            boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: '1px solid #EEEFF2 !important' }
                                        }}>
                                        <MenuItem value={vendorId}>{vendorName}</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                        <div className='w-full pb-4'>
                            <p className="text-[14px] text-[#718096]">{t('purchaseLocation')} *</p>
                            <div className='w-full'>
                                <FormControl sx={{ width: '100%' }}>
                                    <Select value={purchaseAddress} disabled
                                        sx={{
                                            width: '100%', background: '#FCFCFC', '.MuiOutlinedInput-input': { padding: '9px !important' },
                                            boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: '1px solid #EEEFF2 !important' }
                                        }}>
                                        <MenuItem value={purchaseAddress}>{purchaseAddressName}</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                        {
                            purchaseAddress ?
                                <div className='w-full p-4 address'>
                                    <div className='w-full'>{address.address}</div>
                                    {purchaseAddress ? <div className='w-full'>{address?.zip} {address?.city}, {address?.state}</div> : <div className='w-full'></div>}
                                </div>
                                :
                                null
                        }
                    </div>
                    <div className='w-full lg:w-3/5 h-fit'>
                        <div className='bg-white pt-0 rounded-md w-full edit-view mb-3'>
                            <div className='pt-1 pl-5'>
                                <p className='text-[13px] font-[600] uppercase text-[#A1ACB8]'>{t('purchaseContractItems')}</p>
                            </div>
                            <div className='flex justify-end p-5 pt-0 border-b'>
                                <Tooltip disableInteractive title={t('addpurchaseContractItems')} placement='bottom'>
                                    <div>
                                        <AddButton onClick={handleCloseItem}><i className="fa-solid fa-plus"></i></AddButton>
                                    </div>
                                </Tooltip>
                            </div>
                            <div>
                                {
                                    items.length > 0 ?
                                        <div className='flex justify-end w-full p-2'>
                                            <button className='px-2 py-1 text-white bg-red-600 font-bold rounded-md mb-1 roboto text-xs uppercase' onClick={e => setItems([])}>{t('clear_all')}</button>
                                        </div>
                                        :
                                        null
                                }
                                <PurchaseContractsItemsTable items={items} setItems={setItems} itemsLength={items.length} handler={updateItem} />
                            </div>
                        </div>
                        <div className='w-full flex justify-end pb-14'>
                            <button type="button" onClick={updatePurchaseContract} className='text-white font-[700] rounded-md py-2.5 px-5 uppercase text-[14px] bg-[#015D9F] hover:bg-[#003459] disabled:bg-[#B8B7BC]'>
                                <span className='pr-2'><i className="fa-solid fa-clock-rotate-left"></i></span> {t('update')}
                            </button>
                        </div>
                    </div>

                </div>
                <AddPurchaseItem open={openItem} handleClose={handleCloseItem} items={items} setItems={setItems} />
            </Box>
        </>
    )
}

export default UpdatePurchaseContracts
